import { UserFindInterface } from '@zaoblako/shared/modules/security/dtos/user/user-find.dto';

export const PURCHASE_USERS: UserFindInterface[] = [
  <UserFindInterface>{
    id: 20,
    job: 'Директор по закупкам',
    name: 'Ромашкин Руслан',
    profile: { name: 'Ромашкин Руслан' },
    deleted: null
  },
  <UserFindInterface>{
    id: 21,
    job: 'Менеджер по закупкам',
    name: 'Тополева Виктория',
    profile: { name: 'Тополева Виктория' },
    deleted: null
  },
  <UserFindInterface>{
    id: 22,
    job: 'Операционный директор',
    name: 'Петров Игнат',
    profile: { name: 'Петров Игнат' },
    deleted: null
  },
  <UserFindInterface>{
    id: 23,
    job: 'Генеральный директор',
    name: 'Сидоров Олег',
    profile: { name: 'Сидоров Олег' },
    deleted: null
  },
  <UserFindInterface>{
    id: 24,
    job: 'Юрист',
    name: 'Голышев Петр',
    profile: { name: 'Голышев Петр' },
    deleted: null
  },
  <UserFindInterface>{
    id: 25,
    job: 'Финансист',
    name: 'Ким Даниил',
    profile: { name: 'Ким Даниил' },
    deleted: null
  }
];
